import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../common/components/table";
import PageLoader from "../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectSystemInformationsListItems } from "../../../../../redux/system-informations/selector";
import { systemInformations } from "../../../../../redux/system-informations/action";


const ManagementSystemInformations = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)

    const itemsData = useSelector(selectSystemInformationsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'AppVersion', headerName: 'AppVersion' },
    { field: 'WhatsNew', headerName: 'WhatsNew' },
    { field: 'CreatedDate', headerName: 'CreatedDate', isDateValueFormat:true }
      
        ]);
      }
     
      const fetchSystemInformations=()=>{
        dispatch(systemInformations.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/system-informations/list`,entity:'systemInformations',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchSystemInformations()
	}, [pageData])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    paginationData={itemsData?.result?.pagination}  headingName="System Informations"/>
     
  }
  </>
	);
};

export default ManagementSystemInformations;


